import { Select } from 'antd';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

const SelectStyled = styled(Select)`
  .ant-select-selector {
    border: 1px solid ${theme.colors.gray_6} !important;
    background: transparent !important;
    padding: 0 16px !important;
  }
  .ant-select-focused {
    border: none !important;
  }
  .ant-select-selection-item {
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.normal};
    line-height: 24px;
    letter-spacing: 0.1px;
    color: ${theme.colors.dark_500};
  }
`;

export default SelectStyled;
